<template>
	<div>
		<validation-observer v-slot="{ passes, invalid }">
			<form @submit.prevent="passes(save)">
				<div>
					<div class="card">
						<div class="card-header py-3 bold text-uppercase">
							<fa-icon
								icon="info"
								class="mr-2"
							/> General
						</div>

						<div class="card-body">
							<div class="row mb-2">
								<div class="col-12 col-sm-4">
									<g-field
										v-model="value.EmpresaNombreComercial"
										:disabled="loading"
										:app="app"
										:item="id"
										name="EmpresaNombreComercial"
										placeholder=""
										title="Nombre"
									/>
								</div>

								<div class="col-12 col-sm-4">
									<g-field
										v-model="value.EmpresaNombre"
										:disabled="loading"
										:app="app"
										:item="id"
										name="EmpresaNombre"
										placeholder=""
										title="Razón Social"
									/>
								</div>

								<div class="col-12 col-sm-4">
									<g-field
										v-model="value.EmpresaCIF"
										:disabled="loading"
										:app="app"
										:item="id"
										name="EmpresaCIF"
										placeholder=""
										title="CIF/NIF/NIE"
									/>
								</div>
							</div>

							<div class="row">
								<div class="col-12 col-sm-6">
									<g-field
										v-model="value.EmpresaTelefono"
										:disabled="loading"
										:app="app"
										:item="id"
										name="EmpresaTelefono"
										placeholder=""
										title="Teléfono"
									/>
								</div>
								<div class="col-12 col-sm-6">
									<g-field
										v-model="value.EmpresaEmail"
										:disabled="loading"
										:app="app"
										:item="id"
										name="EmpresaEmail"
										placeholder=""
										title="Email"
									/>
								</div>
							</div>
						</div>
					</div>

					<div class="card">
						<div class="card-header py-3 bold text-uppercase">
							<fa-icon
								icon="map-marker"
								class="mr-2"
							/> Datos Geográficos
						</div>

						<div class="card-body">
							<div class="row mb-4">
								<div class="col-12">
									<label>Domicilio Social:</label>
									<vue-google-autocomplete
										id="map"
										ref="map"
										classname="form-control"
										placeholder=""
										:disabled="loading"
										:value="value.EmpresaDomicilioSocial"
										@placechanged="inputPlace"
										@inputChange="inputChange"
										@change="inputChange2"
									/>
								</div>
							</div>

							<div class="row">
								<div class="col-12 col-sm-3">
									<g-field
										v-model="value.EmpresaCP"
										:app="app"
										:item="id"
										name="EmpresaCP"
										placeholder=""
										title="Código Postal"
										:disabled="loading"
									/>
								</div>

								<div class="col-12 col-sm-3">
									<g-field
										v-model="value.EmpresaLocalidad"
										:disabled="loading"
										:app="app"
										:item="id"
										name="EmpresaLocalidad"
										placeholder=""
										title="Localidad"
									/>
								</div>

								<div class="col-12 col-sm-3">
									<g-field
										v-model="value.EmpresaProvincia"
										:disabled="loading"
										:app="app"
										:item="id"
										name="EmpresaProvincia"
										placeholder=""
										title="Provincia"
									/>
								</div>

								<div class="col-12 col-sm-3">
									<g-field
										v-model="value.EmpresaPais"
										:disabled="loading"
										:app="app"
										:item="id"
										name="EmpresaPais"
										placeholder=""
										title="Pais"
									/>
								</div>
							</div>
						</div>
					</div>

					<div class="card">
						<div class="card-header py-3 bold text-uppercase">
							<fa-icon
								icon="map-marker"
								class="mr-2"
							/> Datos de facturación
						</div>

						<div class="card-body">
							<div class="row mb-4">
								<div class="col-12">
									<g-field
										v-model="value.EmpresaFormaPago"
										:disabled="loading"
										:app="app"
										:item="id"
										name="EmpresaFormaPago"
										placeholder=""
										title="Forma de pago"
									/>
								</div>
							</div>

							<div class="row">
								<div class="col-12 col-sm-6">
									<g-field
										v-model="value.EmpresaCuentaBancaria"
										:disabled="loading"
										:app="app"
										:item="id"
										name="EmpresaCuentaBancaria"
										placeholder=""
										title="IBAN"
									/>
								</div>

								<div class="col-12 col-sm-6">
									<g-field
										v-model="value.EmpresaBIC"
										:disabled="loading"
										:app="app"
										:item="id"
										name="EmpresaBIC"
										placeholder=""
										title="BIC/SWIFT"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col-12 text-right">
						<a-button
							type="primary"
							html-type="submit"
							:disabled="invalid"
							:loading="loading"
						>
							<fa-icon
								:icon="['far','plus-square']"
								class="mr-2"
							/> <b>MODIFICAR</b>
						</a-button>
					</div>
				</div>
			</form>
		</validation-observer>
	</div>
</template>

<script>
import VueGoogleAutocomplete from 'vue-google-autocomplete';

export default {
	components: { VueGoogleAutocomplete },
	props: {
		value: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			app: 'empresas',
			loading: false
		};
	},
	computed: {
		id() {
			return this.value._EntityId;
		}
	},
	methods: {
		async save() {
			this.loading = true;

			const params = {
				EmpresaNombreComercial: this.value.EmpresaNombreComercial,
				EmpresaNombre: this.value.EmpresaNombre,
				EmpresaCIF: this.value.EmpresaCIF,
				EmpresaDomicilioSocial: this.value.EmpresaDomicilioSocial,
				EmpresaCP: this.value.EmpresaCP,
				EmpresaLocalidad: this.value.EmpresaLocalidad,
				EmpresaProvincia: this.value.EmpresaProvincia,
				EmpresaPais: this.value.EmpresaPais,
				EmpresaTelefono: this.value.EmpresaTelefono,
				EmpresaEmail: this.value.EmpresaEmail
			};

			const data = await this.$gestios.items('empresas').edit({ params, id: this.id });

			this.loading = false;

			if (data.ok) this.$toast.success('Empresa modificada correctamente');
		},
		inputPlace(place) {
			if (place.administrative_area_level_1) {
				this.value.EmpresaProvincia = place.administrative_area_level_1;
			}

			if (place.locality) this.value.EmpresaLocalidad = place.locality;
			if (place.postal_code) this.value.EmpresaCP = place.postal_code;
			if (place.country) this.value.EmpresaPais = place.country;
		},
		inputChange(data) {
			this.value.EmpresaDomicilioSocial = data.newVal;
		},
		inputChange2(data) {
			this.value.EmpresaDomicilioSocial = data;
		}
	}
};
</script>

<style lang="scss" scoped>

</style>
